import React from 'react'
import { confirmAlert } from 'react-confirm-alert';
import { useAlert } from "react-alert";

export default function DeleteRow({ type, id, title }) {
    let alert = useAlert();
    const deleteImage = (index, onImageRemove) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="AlertUI">
                        <h1>Aviso</h1>
                        <p>
                            ¿Deseas eliminar el registro {title}?
                        </p>
                        <button onClick={onClose}>No</button>
                        <button
                            onClick={() => {
                                fetch(`${process.env.REACT_APP_URL_API}/data/deleteRow`, {
                                    method: "POST",
                                    mode: "cors",
                                    headers: {
                                        "Cache-Control": "no-cache",
                                        "Access-Control-Allow-Origin": "*",
                                    },
                                    body: JSON.stringify({ id: id, type: type.toLowerCase() }),
                                })
                                    .then((response) => response.json())
                                    .then((datar) => {
                                        if (datar.rows > 0) {
                                            alert.show("Registro Eliminado", {
                                                timeout: 3000,
                                                type: "success",
                                                onClose: () => {                                                    
                                                    window.location.reload();
                                                },
                                            });
                                        }
                                    })
                                    .catch((error) => {
                                        alert.show(
                                            "Ocurrió un error al borrar el registro, por favor intenta de nuevo: " +
                                            error,
                                            {
                                                timeout: 3000,
                                                type: "error",
                                            }
                                        );
                                    });
                            }}
                        >
                            Si
                        </button>
                    </div>
                );
            },
        });
    }

    return (
        <button className="btn btn-danger" onClick={() => {
            deleteImage()
        }}>Eliminar</button>
    )
}
